import dataPeriDabi from "../../../../src/data/periprocedureel-beleid-dabigatran.json";
import BasicSchematic from "../../../../src/components/chart/interaction/basic-schematic/Chart.js";
import * as React from 'react';
export default {
  dataPeriDabi,
  BasicSchematic,
  React
};